module.exports = __webpack_public_path__ + "img/C08TechVimanaChampion_ua.5f07b09c.webp";